import React from "react";
import styles from "./ClientSection.module.css";
import tata_cap from "../../images/Clients/tata_cap.svg";
import axis from "../../images/Clients/axis.svg";
import axis_sec from "../../images/Clients/axis_sec.svg";
import rbl from "../../images/Clients/rbl.svg";
import indusInd from "../../images/Clients/IndusInd.svg";
import smb from "../../images/Clients/smb.svg";
import ipru from "../../images/Clients/ipru.svg";

const clients = [
  { name: "IndusInd Bank", className: "indusindBank", url: indusInd },
  { name: "TATA CAPITAL", className: "tataCapital", url: tata_cap },
  { name: "RBL BANK", className: "rblBank", url: rbl },
  // { name: "SBM", className: "sbm", url: smb },
  // { name: "AXIS BANK", className: "axisBank", url: axis },
  // { name: "AXIS SECURITIES", className: "axisSecurities", url: axis_sec },
  // { name: "ICICI PRUDENTIAL", className: "iciciPrudential", url: ipru },
];

const ClientSection = () => {
  return (
    <section className={styles.section}>
      <div className={styles.heading}>
        <h2>Our Clients</h2>
        {/* <p style={{ marginBottom: 0 }}>
          Eliminate the need for multiple-point solutions. Evalnext's unified
          platform offers centralized solutions for risk and compliance
          challenges. Our user-friendly interface enables informed
          decision-making across stakeholders and functions, while robust
          features enable automation and reduce effort.
        </p> */}
      </div>
      <div className={styles.ClientLogoSec1Wrap}>
        <div className={styles.ClientLogoSec1}>
          {clients.map((client, index) => {
            if (index > 3) return <></>;
            return (
              <div
                key={client.name}
                className={`${styles.clientLogo} ${styles[client.className]}`}
              >
                <img src={client.url} height={112} alt={client.name} />
              </div>
            );
          })}
        </div>
        <div className={styles.ClientLogoSec1}>
          {clients.map((client, index) => {
            if (index < 4) return <></>;
            return (
              <div
                key={client.name}
                className={`${styles.clientLogo} ${styles[client.className]}`}
              >
                <img src={client.url} height={112} alt={client.name} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ClientSection;
